import { toWhatsAppNumber } from './phone';

/** `https://wa.me/233...?text=...` or null when the published number is missing/invalid. */
export function whatsAppLink(number: string | null | undefined, message?: string): string | null {
  const digits = toWhatsAppNumber(number);
  if (!digits) return null;
  return message
    ? `https://wa.me/${digits}?text=${encodeURIComponent(message)}`
    : `https://wa.me/${digits}`;
}

/** Fills the published `{spots}`, `{trip}`, `{ref}` placeholders. */
export function fillTemplate(
  template: string,
  values: { spots: string; trip: string; ref: string },
): string {
  return template
    .replaceAll('{spots}', values.spots)
    .replaceAll('{trip}', values.trip)
    .replaceAll('{ref}', values.ref);
}

export const DEFAULT_RESERVATION_MESSAGE =
  'Hi TripCircle, I reserved {spots} on {trip}. My booking reference is {ref}. Sending the payment screenshot here.';

export const DEFAULT_QUESTION_MESSAGE = 'Hi TripCircle, I have a question about a trip.';
